export default __webpack_public_path__ + "static/media/spark.0ac8a388.mp4";